import React, { ReactNode } from "react";

import classNames from "classnames";

import "./categoryTag.scss";

export type TagVariant = "primary"
  | "registration"
  | "events"
  | "secondary"
  | "donation"
  | "tertiary"
  | "learn-area"
  | "learn-topic" // TODO: TS This variant has no corresponding color but is used as tag variant
  | "faq"
  | "light"
  | "dark"
  | undefined;

interface CategoryTagProps {
  children: ReactNode;
  variant?: TagVariant;
  small?: boolean;
}

const CategoryTag: React.FC<CategoryTagProps> = ({ children, variant = undefined, small = false }) => (
  <div
    className={classNames(
      "category-tag",
      {
        "category-tag--small": small,
        [`category-tag--${variant}`]: variant,
      },
    )}
  >
    <span>
      {children}
    </span>
  </div>
);

export default CategoryTag;
